module.exports = __webpack_public_path__ + "static/img/3.9eee484.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newTwo/3.png
// module id = 2ACd
// module chunks = 0